"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconCheck', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M7.00001 12C6.8684 12.0008 6.73794 11.9755 6.6161 11.9258C6.49426 11.876 6.38345 11.8027 6.29001 11.71L3.29001 8.71C3.1017 8.52302 2.99539 8.2689 2.99445 8.00353C2.99351 7.73817 3.09803 7.4833 3.28501 7.295C3.47199 7.1067 3.72611 7.00038 3.99147 6.99944C4.25684 6.99851 4.5117 7.10302 4.70001 7.29L6.93001 9.53L11.24 4.35C11.3241 4.24888 11.4272 4.16531 11.5435 4.10405C11.6599 4.04279 11.7872 4.00505 11.9181 3.99298C12.049 3.98091 12.181 3.99474 12.3066 4.03369C12.4322 4.07265 12.5489 4.13595 12.65 4.22C12.7511 4.30405 12.8347 4.40719 12.896 4.52353C12.9572 4.63987 12.995 4.76715 13.007 4.89808C13.0191 5.02901 13.0053 5.16103 12.9663 5.28662C12.9274 5.4122 12.8641 5.52888 12.78 5.63L7.78001 11.63C7.68589 11.746 7.56697 11.8395 7.43199 11.9035C7.29701 11.9675 7.1494 12.0005 7.00001 12Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M8.49999 15.51C8.36839 15.5108 8.23792 15.4855 8.11609 15.4358C7.99425 15.386 7.88343 15.3127 7.78999 15.22L3.27999 10.71C3.09169 10.5217 2.9859 10.2663 2.9859 10C2.9859 9.7337 3.09169 9.4783 3.27999 9.29C3.4683 9.1017 3.72369 8.99591 3.98999 8.99591C4.25629 8.99591 4.51169 9.1017 4.69999 9.29L8.42999 13L15.25 4.82C15.4197 4.61578 15.6636 4.48736 15.9281 4.46298C16.1925 4.4386 16.4558 4.52026 16.66 4.69C16.8642 4.85974 16.9926 5.10365 17.017 5.36808C17.0414 5.6325 16.9597 5.89578 16.79 6.1L9.26999 15.1C9.18147 15.2066 9.07176 15.2937 8.94782 15.3556C8.82387 15.4176 8.6884 15.4532 8.54999 15.46L8.49999 15.51Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M10.25 18.26C9.98842 18.2696 9.73351 18.1762 9.53999 18L4.27999 12.71C4.18626 12.617 4.11187 12.5064 4.0611 12.3846C4.01033 12.2627 3.98419 12.132 3.98419 12C3.98419 11.868 4.01033 11.7373 4.0611 11.6154C4.11187 11.4936 4.18626 11.383 4.27999 11.29C4.46735 11.1037 4.7208 10.9992 4.98499 10.9992C5.24918 10.9992 5.50263 11.1037 5.68999 11.29L10.18 15.78L18.25 6.1C18.3303 5.98856 18.4328 5.89487 18.5509 5.82478C18.6691 5.75468 18.8004 5.70969 18.9367 5.6926C19.0731 5.6755 19.2114 5.68668 19.3432 5.72544C19.475 5.76419 19.5974 5.82969 19.7028 5.91784C19.8082 6.00599 19.8943 6.11491 19.9557 6.2378C20.0171 6.3607 20.0525 6.49492 20.0598 6.63212C20.067 6.76931 20.0459 6.90652 19.9978 7.03519C19.9496 7.16387 19.8755 7.28125 19.78 7.38L11 17.9C10.9115 18.0066 10.8018 18.0937 10.6778 18.1556C10.5539 18.2176 10.4184 18.2532 10.28 18.26H10.25Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M13.5 23.5C13.3684 23.5008 13.2379 23.4755 13.1161 23.4258C12.9943 23.376 12.8835 23.3027 12.79 23.21L5.29002 15.7C5.12619 15.5087 5.04059 15.2626 5.05031 15.0109C5.06003 14.7593 5.16436 14.5205 5.34245 14.3424C5.52055 14.1643 5.75929 14.06 6.01096 14.0503C6.26264 14.0406 6.50872 14.1262 6.70002 14.29L13.43 21L25.24 6.85C25.4098 6.64578 25.6537 6.51736 25.9181 6.49298C26.1825 6.4686 26.4458 6.55026 26.65 6.72C26.8542 6.88974 26.9827 7.13365 27.007 7.39808C27.0314 7.6625 26.9498 7.92578 26.78 8.13L14.27 23.13C14.1804 23.2378 14.0691 23.3256 13.9433 23.3876C13.8175 23.4497 13.6801 23.4845 13.54 23.49L13.5 23.5Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;